import httpClient from '../httpClient';

export const addSubscriber = async (
  email,
  firstname = '',
  lastname = '',
  tags = [],
) => {
  const result = await httpClient.post('/mailchimp/add-subscriber', {
    email: email,
    firstname: firstname,
    lastname: lastname,
    tags: tags,
  });
  return result.data;
};
